export class PromotionSearchProduct {
    constructor(promotionData = null) {
        if (promotionData) {
            this.currentPage = promotionData?.currentPage || 1;
            this.perPage = promotionData?.perPage || 0;
            this.total = promotionData?.total || 0;
            this.totalPages = promotionData?.totalPages || 0;
            this.products = promotionData?.data?.length ? promotionData.data.map(product => new SearchProduct(product)) : [];
        }
    }
}

export class SearchProduct {
    constructor(data = null) {
        if (data) {
            this.id = data?.id || '';
            this.identifier = data?.identifier || '';
            this.fullname = data?.fullname || '';
            this.sku = data?.sku || '';
            this.multidimensional = data?.multidimensional || false;
            this.isKitProduct = data?.isKitProduct || false;
            this.galleryImages = data?.galleryImages || [];
            this.thumbnailImages = data?.thumbnailImages || [];
            this.prices = data?.prices || [];
            this.description = data?.description || '';
            this.stock = data?.stock || {};
            this.paymentOptions = data?.paymentOptions || [];
            this.baseOptions = data?.baseOptions || [];
            this.amwayValue = data?.amwayValue || {};
            this.kitEntries = data?.kitEntries || [];
            this.categories = data?.categories || [];
            this.isEligibleForMyList = data?.isEligibleForMyList || false;
            this.hasAStarter = data?.hasAStarter || false;
            this.amwayAPointOptions = data?.amwayAPointOptions || [];
            this.customerSelling = data?.customerSelling || false;
            this.remainingCoupons = data?.remainingCoupons || 0;
            this.redeemCondition = data?.redeemCondition || '';
            this.quantity = data?.quantity || 0;
        }
    }
}

export class PromotionSearchKeywords {
    constructor(data = null) {
        this.id = data?.id || '';
        this.keyword = data?.keyword || '';
    }
}